import { useRef } from "react";
import textWeight from "../../utils/textWeight";
export default (onClick) => {
  const { TextWeight } = textWeight();
  const fileInputRef = useRef(null);

  const handleClick = () => {
    if (onClick) {
      onClick(); // ✅ external navigation logic
    } else {
      fileInputRef.current.click(); // ✅ default: open file picker
    }
  };
  return { TextWeight, fileInputRef, handleClick };
};
